import intersection from "lodash/intersection";
import type { Student } from "../providers/studentsProvider";

export function filterByOnboardingIssues(students: Student[], onboardingIssues: string[]): Student[] {
  if (onboardingIssues.length === 0) {
    return students;
  }
  return students.filter((student) => {
    const studentOnboardingTruthyKeys = Object.entries(student.onboardingIssues).reduce<Array<string>>(
      (acc, [key, value]) => (value ? [...acc, key] : acc),
      [],
    );
    return intersection(onboardingIssues, studentOnboardingTruthyKeys).length > 0;
  });
}
